import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import RevScalePage from "./pages/RevScalePage";
import LeadershipHiringPage from "./pages/LeadershipHiringPage";
import ProductRoadmappingPage from "./pages/ProductRoadmappingPage";
import CorporateGolfPage from "./pages/CorporateGolfPage";
import WhyFractionalPage from "./pages/WhyFractionalPage";
import ROICalculatorPage from "./pages/ROICalculatorPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<HomePage />} />
            <Route path="/services/revscale" element={<RevScalePage />} />
            <Route path="/services/leadership-hiring" element={<LeadershipHiringPage />} />
            <Route path="/services/product-roadmapping" element={<ProductRoadmappingPage />} />
            <Route path="/services/corporate-golf" element={<CorporateGolfPage />} />
            <Route path="/why-fractional" element={<WhyFractionalPage />} />
            <Route path="/roi-calculator" element={<ROICalculatorPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
